// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page/infographic-page.component.scss
// module id = 383
// module chunks = 0